/* Stylesheet */

.glossary_entry {
  padding: 21px;
  box-shadow: var(--ion-box-shadow);
  background: var(--ion-gradient-light);
  border-radius: 5px;

  .title {
    color: var(--ion-color-text-primary);
  }

  .content {
    margin: 21px 0px 0px 0px;
    max-height: 121px;
    line-height: 1.5;
    color: var(--ion-color-text-primary);
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-clamp: 5;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
  }
}
